import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import { ProtectedLayout, RequireOrgLayout, RequireOnboardingLayout, PublicOnly } from "@/auth/guards";
import { AppLayout } from "@/components/layout/AppLayout";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AcceptInvite from "@/pages/auth/AcceptInvite";
import Onboarding from "@/pages/Onboarding";
import OrganizationSetup from "@/pages/OrganizationSetup";
import PilotDemoSavoie from "@/pages/PilotDemoSavoie";
import Dashboard from "@/pages/Dashboard";
import Markets from "@/pages/Markets";
import MarketIntelligence from "@/pages/MarketIntelligence";
import Opportunities from "@/pages/Opportunities";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import DataHub from "@/pages/DataHub";
import DataSources from "@/pages/DataSources";
import AskLodge from "@/pages/AskLodge";
import Partners from "@/pages/Partners";
import Campaigns from "@/pages/Campaigns";
import Performance from "@/pages/Performance";
import GsaWorldwide from "@/pages/GsaWorldwide";
import AdminPanel from "@/pages/AdminPanel";
import PricingPage from "@/pages/PricingPage";
import AcceptPartner from "@/pages/auth/AcceptPartner";
import ComingSoon from "@/pages/ComingSoon";
import DemoEntry from "@/pages/DemoEntry";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              {/* Public (redirect if already authenticated) */}
              <Route element={<PublicOnly />}>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
              </Route>

              {/* Public, accessible regardless of auth */}
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/accept-invite" element={<AcceptInvite />} />
              <Route path="/accept-partner" element={<AcceptPartner />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/demo" element={<DemoEntry />} />
              {/* Phase 3D.1-B4-C: standalone flag-guarded synthetic pilot demo (no auth/nav) */}
              <Route path="/pilot-demo/savoie" element={<PilotDemoSavoie />} />


              {/* Authenticated */}
              <Route element={<ProtectedLayout />}>
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/organization-setup" element={<OrganizationSetup />} />

                {/* Requires at least one organization */}
                <Route element={<RequireOrgLayout />}>
                  <Route element={<RequireOnboardingLayout />}>
                    <Route element={<AppLayout />}>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/markets" element={<Markets />} />
                      <Route path="/markets/:marketId" element={<MarketIntelligence />} />
                      <Route path="/opportunities" element={<Opportunities />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/data-hub" element={<DataHub />} />
                      <Route path="/data-sources" element={<DataSources />} />
                      <Route path="/partners" element={<Partners />} />
                      <Route path="/campaigns" element={<Campaigns />} />
                      <Route path="/performance" element={<Performance />} />
                      <Route path="/ask-lodge" element={<AskLodge />} />
                      <Route path="/gsa-worldwide" element={<GsaWorldwide />} />
                    </Route>
                  </Route>
                </Route>
              </Route>

              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
